const USER_TYPE = {
    PERSONAL: 'PERSONAL',
    STANDARD: 'STANDARD',
    PRO: 'PRO',
    PLUS: 'PLUS',
    REVIEWER: 'REVIEWER',
    BETA: 'BETA',
    BELIEVER: 'BELIEVER',
    UNLIMITED: 'UNLIMITED'
};

export default USER_TYPE;
